module.exports = __webpack_public_path__ + "static/media/cc-bobina2.8e5e71c5.jpg";